import type { DocumentPickerAsset, DocumentPickerResult } from 'expo-document-picker'

export type ExpoDocumentPickerFile = Pick<DocumentPickerResult, 'output'> &
  Required<Pick<DocumentPickerAsset, 'uri' | 'mimeType' | 'name'>>

type ExpoUploadFileParams = Parameters<typeof import('expo-file-system').uploadAsync>

export async function uploadFile(
  file: ExpoDocumentPickerFile,
  uploadUrl: ExpoUploadFileParams[1],
  method: Extract<NonNullable<ExpoUploadFileParams[2]>['httpMethod'], 'PUT' | 'POST'> = 'PUT',
) {
  const body = file.output?.[0]
  if (!body) throw new Error('file info missing', { cause: { file, uploadUrl, method } })
  await fetch(uploadUrl, { method, headers: { 'Content-Type': file.mimeType }, body })
}
